import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, Checkbox, Input, message, Table } from "antd";
import { hasSubstring } from "../../../extensions/helper";
import Room from "./room";
import { RefreshButton } from "../../../extensions/design";

const Rooms = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [filter, setFilter] = useState({ showHidden: false, serchText: ""});
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    serverFetch("room")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const columns = [
    {title: "#", dataIndex: "id", width: 100 },
    {title: "Пор", dataIndex: "idx", width: 48 },
    {title: "Акт", dataIndex: "active", width: 48, align: "center", render: value => <Checkbox checked={value}/> },
    {dataIndex: "imageId", width: 48, align: "center", render: (imageId, record, index) => (
      <img
        id={`tour-item-settings-rooms-image-${index}`} 
        src={imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${imageId}.jpg` : "/images/room.svg"} 
        alt={record.name} 
        style={{ maxWidth: "100%", maxHeight: 32, objectFit: "contain", display: "block", margin: "0 auto" }}
      />
    )},
    {title: "Наименование", dataIndex: "name", width: 400 },
    {title: "Календарь", dataIndex: "calendarName", },
    {title: "Описание", dataIndex: "description", },
    {title: "Вход за, мин.", dataIndex: "qtyMinBeforeEnter", }
  ]

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  }

  const divItem = editId != null && <Room id={editId} onClose={onClose} />
  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  const onChangeFilter = value => setFilter({ ...filter, ...value });

  const filtered = items.filter(item => {
    if (!filter.showHidden && !item.active) return false;
    if (!hasSubstring(filter.serchText, item.name)) return false;
    return true;
  })

  return<div>
    <div className="sport-form-title">
      <Checkbox checked={filter.showHidden} onChange={e => onChangeFilter({ showHidden: e.target.checked })}>Показывать неактивные</Checkbox>
      <Input placeholder="Поиск" value={filter.serchText} onChange={e => onChangeFilter({serchText: e.target.value})} />
      <RefreshButton onClick={getData}/>
      <Button onClick={() => setEditId(0)}>Новый</Button>
    </div>
    <div ref={divRef} style={{width: tableWidth}}>
      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({onClick: () => {setEditId(record.id)}})}
      /> 
    </div>
    {divItem}
  </div>
}

export default Rooms;

